import './_product-rose-options.scss';
import component from './product-rose-options';

export default component;
